export default __webpack_public_path__ + "static/media/check.e80dd3cf.png";